import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpErrorResponse
} from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Router } from "@angular/router";
import { AuthService } from '../auth/auth.service';
import { LoginComponent } from 'src/app/shared/components/login/login.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})
export class AuthInterceptorService implements HttpInterceptor {
  constructor(
    private router: Router,
    private _authService: AuthService,
    private modalService: BsModalService
  ) { }
  modalref: BsModalRef;

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    request = request.clone({
      setHeaders: {
        'X-Client-Id': environment.clientId,
        'X-Project-Id': environment.projectId
      }
    });
    if(request.headers.get('X-Country-Id')){

    }
    else if(localStorage.getItem("userCountry")){
      let userCountry = JSON.parse(localStorage.getItem('userCountry'));
        if(userCountry){
          request = request.clone({
            setHeaders: {
              'X-Country-Id': userCountry.id ? userCountry.id : userCountry.attributes.id
            }
          });
        }
    }
    if (sessionStorage.getItem("userLanguage")) {
      let userLanguage = JSON.parse(sessionStorage.getItem('userLanguage'));
      request = request.clone({
        setHeaders: {
          'X-Language-Id': userLanguage.id ? userLanguage.id : userLanguage.attributes.id
        }
      });
    }
    if(sessionStorage.getItem("userVerifiedBin")) {
      let bin = sessionStorage.getItem("userVerifiedBin");
      request = request.clone({
        setHeaders: {
          'X-Login-Bin': bin
        }
      });
    }
    var currentUser;
    if (localStorage.getItem('currentUser')) {
      currentUser = JSON.parse(localStorage.getItem('currentUser'));
      if (currentUser.token) {
        request = request.clone({
          setHeaders: {
            'Authorization': "Bearer " + `${currentUser.token}`
          }
        });
      }
    }else {
      let country = localStorage.getItem('countryCode');
        if (country) {
          request = request.clone({
            setHeaders: {
              'cf-country': country,
            },
          });
        }
    }
    return next.handle(request).pipe(
      tap(
        (response: HttpEvent<any>) => {
          // console.log(response);
        },
        (error: HttpErrorResponse) => {
          // if (error["status"] == 401){
          //   this._authService.logout(false);

          //   if (!error.url.endsWith('/cs/v1/user') && !error.url.endsWith('/user/user_cards')) {
          //     var config = {
          //       backdrop: true,
          //       ignoreBackdropClick: false,
          //       class: 'login-modal'
          //     };
          //     this.modalref = this.modalService.show(LoginComponent, Object.assign({}, config, {}));
          //     this.modalref.content.closeModal.subscribe(res => {
          //       this.modalref.hide();
          //     })
          //   }
          // }
          // else if (error["status"] != 200 && error["status"] != 401 && error["status"] != 404) {
            // this.router.navigate(["error"]);
          // }
        }
      )
    );
  }

}
